<template>
  <div class="m-login__signin flipInX animated">
    <div class="m-login__form m-form mt-4 text-center ">
      <p><i class="fa fa-exclamation-triangle text-danger" style="font-size: 10em !important;"></i></p>
      <p v-if="accountBlocked">Usługa jest tymczasowo niedostępna. Spróbuj ponownie później lub skontaktuj się z organizatorem programu.</p>
      <p v-else>Moduł klienta jest wyłączony.</p>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: "DisabledLogin",
    computed: {
      ...mapState({
        accountBlocked: state => state.settings.accountBlocked
      })
    }
  }
</script>

<style scoped>

</style>
